import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("elvosh_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export function mediaUrl(url) {
    if (!url) return "";
    if (url.startsWith("http")) return url;
    return `${BACKEND_URL}${url}`;
}

export function formatPrice(n) {
    if (n === null || n === undefined) return "₹0";
    return "₹" + Number(n).toLocaleString("en-IN", { maximumFractionDigits: 0 });
}

export function apiError(e, fallback = "Something went wrong. Please try again.") {
    const d = e?.response?.data?.detail;
    if (!d) return e?.message || fallback;
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
    if (d?.msg) return d.msg;
    return fallback;
}

export default api;
